<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <LayoutTheHeader
      isTemplate2
      :route-path="routePath"
      @open-login="openLogin"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main :class="{ 'pt-[3.75rem]': !isHome }">
      <slot />
    </main>
    <LayoutTheFooterThree />
    <button class="whatsapp-float-button" @click="openWhatsappContainer">
      <icon-whatsapp class="base-icon text-heading-2 text-white w-5 h-5" />
      <span>
        {{ $t("whatsapp.title") }}
      </span>
    </button>
  </Html>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from "nuxt/app";
const authRef = ref<any>(null);
function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: "id",
  addSeoAttributes: true,
});
const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
const openWhatsappContainer = () => {
  window.open(`https://wa.me/message/${config.public.whatsapp}`, "_blank");
};
const localePath = useLocalePath();

const route = useRoute();
const routePath = ref(route.path);

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true }
);
</script>
<style scoped lang="scss">
.whatsapp-float-button {
  @apply fixed ltr:right-5 rtl:left-5 md:ltr:right-6 md:rtl:left-6 bottom-5 px-2 py-2 cursor-pointer flex items-center gap-1 z-10 rounded-[10px];
  background: linear-gradient(106.85deg, #67ec6f 15.15%, #00a014 81.18%);

  & span {
    @apply text-heading-6 text-white max-md:hidden font-bold;
  }
}
</style>
